import { getInboxV2Boards } from "../../../api/inbox-v2";

import type { InboxV2BoardsPayload } from "../../types";
import { mapInboxV2BoardDtoToBoard, mapInboxV2FeedDtoToFeed } from "../mapper";
import {
  getInboxV2CachedApiResponse,
  invalidateInboxV2ApiCacheByPrefix,
  type InboxV2ApiCacheOptions,
} from "./api-cache";

export const INBOX_V2_GET_BOARDS_CACHE_KEY = "inbox-v2:getBoards";
const INBOX_V2_GET_BOARDS_CACHE_EXPIRE_MS = 300_000;

export function invalidateInboxV2GetBoardsCache() {
  invalidateInboxV2ApiCacheByPrefix(INBOX_V2_GET_BOARDS_CACHE_KEY);
}

export function getInboxV2BoardsCacheKey(workspaceId?: string) {
  return workspaceId
    ? `${INBOX_V2_GET_BOARDS_CACHE_KEY}:${workspaceId}`
    : INBOX_V2_GET_BOARDS_CACHE_KEY;
}

export async function getInboxV2BoardsPayload(
  options: Partial<InboxV2ApiCacheOptions> = {}
) {
  return getInboxV2CachedApiResponse<InboxV2BoardsPayload>(
    {
      cacheKey: options.cacheKey ?? INBOX_V2_GET_BOARDS_CACHE_KEY,
      expireMs: options.expireMs ?? INBOX_V2_GET_BOARDS_CACHE_EXPIRE_MS,
      forceNoCache: options.forceNoCache,
    },
    async () => {
      const payload = await getInboxV2Boards();

      return {
        accounts: [],
        boards: payload.boards.map((board) => mapInboxV2BoardDtoToBoard(board)),
        feeds: payload.feeds.map((feed) => mapInboxV2FeedDtoToFeed(feed)),
        hasLimitedAccountAccess: payload.hasLimitedAccountAccess,
        tags: [],
      } satisfies InboxV2BoardsPayload;
    }
  );
}
